import { Tooltip } from '@devstart/react-bootstrap';
import getColors from '@utils/colors';
import { isDarkMode } from '@utils/theme';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Overlay from 'react-overlays/Overlay';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import PointsIcon from '../../../assets/icons/points-header';
import { ThemeInterface } from '../../../redux/prop-types';
import {
  completedChallengeCount,
  themeSelector
} from '../../../redux/selectors';

import './points.css';

interface PointsProps {
  completedChallengeCount: number;
  theme: ThemeInterface;
}

const mapStateToProps = createSelector(
  completedChallengeCount,
  themeSelector,
  (completedChallengeCount: number, theme: ThemeInterface) => ({
    completedChallengeCount: completedChallengeCount,
    theme
  })
);

const Points = ({ completedChallengeCount, theme }: PointsProps): JSX.Element => {
  const { t } = useTranslation();
  const points = 50 + completedChallengeCount * 10;

  const triggerRef = useRef(null);
  const containerRef = useRef(null);

  const [shown, setShown] = useState(false);

  const hover = {
    onMouseEnter: () => setShown(!shown),
    onMouseLeave: () => setShown(!shown)
  };

  return (
    <div {...hover}>
      <div id='points' className='points-container' ref={triggerRef}>
        <PointsIcon
          fill={
            isDarkMode(theme?.currentTheme)
              ? 'rgba(255, 255, 255, 0.8)'
              : getColors().color4
          }
        />
        <p className='points-number-text'>{points}</p>
      </div>

      <div className='menu-overlay-container' ref={containerRef}>
        <Overlay
          show={shown}
          rootClose
          container={containerRef}
          offset={[10, 16]}
          target={triggerRef}
          onHide={() => setShown(false)}
          placement='bottom-end'
        >
          {({ props }) => (
            <Tooltip id='point-tooltip'>
              <div {...props} className='menu-overlay' id='menu-overlay'>
                <span>{t('learn.points-description')}</span>
              </div>
            </Tooltip>
          )}
        </Overlay>
      </div>
    </div>
  );
};

Points.displayName = 'Points';

export default connect(mapStateToProps)(Points);
